import { render, staticRenderFns } from "./Home.new-global-offers.vue?vue&type=template&id=1654013c&scoped=true&"
import script from "./Home.new-global-offers.vue?vue&type=script&lang=js&"
export * from "./Home.new-global-offers.vue?vue&type=script&lang=js&"
import style0 from "./Home.new-global-offers.vue?vue&type=style&index=0&id=1654013c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1654013c",
  null
  
)

export default component.exports